import React, { Component } from 'react';
import { APIProvider, Map, useMap } from '@vis.gl/react-google-maps';
import NewNoteMarker from './NewNoteMarker';
import NoteMarker from './NoteMarker';
import HeatmapLayer from '../MapFeatures/HeatmapLayer';

class NotesMap extends Component {
	state = { openNoteKey: '' };

	onClickNoteMarker = note => {
		this.setState({ openNoteKey: note.key });

	}
	onCloseClickMarker = () => {
		this.setState({ openNoteKey: '' });
	}

	render() {
		const { props, state } = this;
		return (
			<APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={['marker']}>
				<Map
					style={{ height: 700 }}
					mapId={"NotesMap"}
					defaultZoom={14}
					defaultCenter={{
						lat: props.location.lat,
						lng: props.location.lng
					}}
					clickableIcons={false}
					onClick={props.onClickMap}
				>
					{props.newNote && (
						<NewNoteMarker
							rootUserData={props.rootUserData}
							newNote={props.newNote}
							onCloseClick={props.onCloseClickNewNoteMarker}
							onSubmit={props.onSubmitCreateNote}
						/>
					)}

					{props.notes.map(note => (
						<NoteMarker
							key={note.key}
							note={note}
							marker={note.marker}
							onClick={() => this.onClickNoteMarker(note)}
							openNoteKey={state.openNoteKey}
							onClickDeleteNote={() => props.onClickDeleteNote(note)}
							onCloseClickInfoWindow={this.onCloseClickMarker}
							unarchiveLog={() => props.unarchiveLog(note)}
							archiveLog={() => props.archiveLog(note)}
						/>
					))}

					<HeatmapLayer
						heatmapPoints={props.heatmapPoints}
						radius={this.props.heatmapMaxIntensity}
					/>

				</Map>
			</APIProvider>
		);
	}
}

export default NotesMap;

/*
					<HeatmapLayer
						data={props.heatmapPoints}
						options={{
							dissipating: true,
							maxIntensity: this.props.heatmapMaxIntensity
						}} />*/
